import { getConfig } from '@edx/frontend-platform'
import { Carousel, DiscoverBanner } from '@blend-ed/blendx-ui'
import { useMemo } from 'react'
import bannerWelcome from '../assets/images/banner-welcome.svg';
import { useBanners } from '@blend-ed/blendx-platform/hooks';

function CarouselContainer() {
    const SITE_NAME = getConfig().SITE_NAME
    const { data, loading } = useBanners()
    const bannerData = useMemo(() => {
        if (data) {
            return data.banners
        }
        return []
    }, [data])

    if (loading) {
        return (
            <div className="my-4">
                <DiscoverBanner
                    loading={true}
                />
            </div>
        )
    }

    return (
        bannerData.length > 0 ? (
            <div>
                <Carousel>
                    {
                        bannerData.map((banner) => (
                            <DiscoverBanner
                                title={banner.title}
                                description={banner.description}
                                badgeText={banner.badge}
                                primaryBtn={{ text: banner.primaryText, url: banner.primaryLink }}
                                secondaryBtn={{ text: banner.secondaryText, url: banner.secondaryLink }}
                                image={banner.imageUrl}
                                variant={banner.variant}
                            />
                        ))
                    }
                </Carousel>
            </div>
        ) : (
            <div className="my-4">
                <DiscoverBanner
                    title={`Welcome to ${SITE_NAME}`}
                    description={`We're excited to have you here!`}
                    badgeText={`New`}
                    primaryBtn={{ text: 'Explore Courses', url: '/dashboard/discover/courses' }}
                    image={bannerWelcome}
                    variant="primary"
                />
            </div>
        )
    )
}

export default CarouselContainer